import { FC, useEffect, useState } from 'react';

interface CountdownTimerProps {
  initialTime: number;
  onComplete: () => void;
  isActive: boolean;
  renderContent?: (timeLeft: number) => string;
}

const CountdownTimer: FC<CountdownTimerProps> = ({
  initialTime,
  onComplete,
  isActive,
  renderContent
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (!isActive) {
      setTimeLeft(initialTime);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onComplete();
          return initialTime;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, initialTime, onComplete]);

  return <>{renderContent ? renderContent(timeLeft) : timeLeft}</>;
};

export default CountdownTimer;
